<div class="fullheight-modal-component">
  <div class="close-btn">
    <mat-icon (click)="closeClick()" svgIcon="close-btn"></mat-icon>
  </div>
  <div mat-dialog-title>
      Código de redefinição enviado
  </div>
  <div mat-dialog-content>
    <span>
      Se houver uma conta  vinculada a este endereço de e-mail, enviaremos instruções para redefinir sua senha.
    </span>
  </div>
  <div mat-dialog-actions>
    <span class="cancel">cancelar</span>
    <button mat-raised-button class="sm">Default</button>
  </div>
</div>